module.exports = __webpack_public_path__ + "img/pressurized_apparatus.bdb0a297.svg";